import React, { useEffect } from 'react';
import './TC.css';

const TC = () => {
  useEffect(() => {
    // Automatically open the PDF in a new tab when page loads
    const pdfUrl = `${process.env.PUBLIC_URL}/images/TC.pdf`;
    window.open(pdfUrl, '_blank');
  }, []);

  const handleDownload = () => {
    const pdfUrl = `${process.env.PUBLIC_URL}/images/TC.pdf`;
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'TC.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <main className="tc-page">
      <div className="tc-container">
        <h1 className="tc-title">TRANSFER CERTIFICATE (TC)</h1>
        <div className="tc-content">
          <p>Your Transfer Certificate is being downloaded automatically.</p>
          <p>If the download didn't start, please click the button below:</p>
          
          <div className="tc-download-section">
            <button onClick={handleDownload} className="download-btn">
              Download TC.pdf
            </button>
            
            <a 
              href={`${process.env.PUBLIC_URL}/images/TC.pdf`} 
              target="_blank" 
              rel="noopener noreferrer"
              className="view-btn"
            >
              View TC.pdf
            </a>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TC;

